module.exports = {"top3":["Infant mortality","Adults without a dental visit","Adults without a usual source of care"],"bottom3":["Drug poisoning deaths","Adults with any mental illness reporting unmet need","Home health patients with a hospital admission"],"most_improved":["Home health patients without improved mobility","Adults with any mental illness who did not receive treatment","Diabetic adults without an annual hemoglobin A1c test"],"most_declined":["Suicide deaths","Preventable hospitalizations ages 18-64","Drug poisoning deaths"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/NH.json
// module id = 270
// module chunks = 143196823979170 184088790168614